/**
 * Org selectors (PX-W6.2) — typed reads over the org slice.
 */

import type { OrgState } from './orgSlice'

interface WithOrg {
  org: OrgState
}

export const selectOrgSettings = (s: WithOrg) => s.org.settings
export const selectOrgSettingsCache = (s: WithOrg) => s.org.settingsCache
export const selectOrgSettingsError = (s: WithOrg) => s.org.settingsError
export const selectSavingOrgSettings = (s: WithOrg) => s.org.savingSettings

export const selectSecuritySettings = (s: WithOrg) => s.org.security
export const selectSecurityCache = (s: WithOrg) => s.org.securityCache
export const selectSecurityError = (s: WithOrg) => s.org.securityError
export const selectSavingSecurity = (s: WithOrg) => s.org.savingSecurity

export const selectAccessGroups = (s: WithOrg) => s.org.groups
export const selectGroupsCache = (s: WithOrg) => s.org.groupsCache
export const selectGroupsError = (s: WithOrg) => s.org.groupsError
export const selectSavingGroup = (s: WithOrg) => s.org.savingGroup

export const selectTenantPolicy = (s: WithOrg) => s.org.tenantPolicy
export const selectPolicyCache = (s: WithOrg) => s.org.policyCache
export const selectPolicyError = (s: WithOrg) => s.org.policyError

export const selectOrgSaveError = (s: WithOrg) => s.org.saveError
